import { getElement } from '../utils'
import { getCaseInsensitiveXPathTextSelector } from '../xpath'

export async function getToggle(label: string): Promise<HTMLElement> {
  const notificationToggleXPath = `//*[@id="toggle" and ${getCaseInsensitiveXPathTextSelector('aria-label', label)}]`

  const toggle = await getElement<HTMLElement>(
    document,
    notificationToggleXPath,
    { timeout: 1000 },
  )
  return toggle
}
